import { useFetch } from '@/hooks/useFetch';
import type { ErrorResponse } from '@/types/apiTypes';
import { useMutation } from '@tanstack/react-query';

export const useBlockClientDraft = () => {
  const { doFetch } = useFetch<void, void>();

  return useMutation<void, ErrorResponse<unknown>, number>({
    mutationFn: async (draftId: number) => {
      return doFetch(`/api/drafts/${draftId}/lock`, {
        method: 'POST',
      });
    },
  });
};